(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[734],{

/***/ 486819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles-v2/[...name]",
      function () {
        return __webpack_require__(941139);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 746000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ isSimpleLink; }
/* harmony export */ });
/**
 * Type guard to check if an item is a simple link (ILpElementLink) or a list (ILpElementSimpleList)
 */ function isSimpleLink(item) {
    return (item === null || item === void 0 ? void 0 : item.fields) != null && "text" in item.fields && "url" in item.fields;
}


/***/ }),

/***/ 995278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PersonInline; },
/* harmony export */   "N": function() { return /* binding */ PersonWithBio; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(269396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135944);
/* harmony import */ var _opendoor_bricks_complex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(472752);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(593298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(208013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4796);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(847208);
/* harmony import */ var _opendoor_bricks_core_Icon_Icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(549154);
/* harmony import */ var _opendoor_bricks_core_Icon_SelectiveSpritesheet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(387583);
/* harmony import */ var _opendoor_bricks_core_Icon_SpritesheetIcons_NewTab__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(142141);
/* harmony import */ var components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(590516);
/* harmony import */ var _helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(358699);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(743613);











// Person component, with a place for extra text (i.e. passed in as children)
var PersonInline = function(props) {
    if (!props.person) {
        return null;
    }
    var _fields = props.person.fields, _firstName = _fields.firstName, firstName = _firstName === void 0 ? "" : _firstName, _lastName = _fields.lastName, lastName = _lastName === void 0 ? "" : _lastName, _picture = _fields.picture, picture = _picture === void 0 ? "" : _picture, credential = _fields.credential, displayName = _fields.displayName;
    var initials = firstName.charAt(0) + lastName.charAt(0);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        alignSelf: "flex-start",
        alignItems: "center",
        children: [
            picture && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                display: [
                    "none",
                    null,
                    null,
                    "initial"
                ],
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_complex__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .q, {
                    size: "lg",
                    src: picture,
                    initials: initials
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                marginLeft: [
                    "0",
                    null,
                    null,
                    picture ? "4" : "0"
                ],
                marginBottom: "0",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                        marginBottom: 0,
                        mt: "0",
                        children: [
                            displayName,
                            credential && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "span"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        children: ",\xa0"
                                    })),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "i"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        fontWeight: "regular",
                                        margin: "0",
                                        children: credential
                                    }))
                                ]
                            })
                        ]
                    })),
                    props.children
                ]
            })
        ]
    }, firstName + lastName);
};
var PersonWithBio = function(props) {
    var _fields = props.person.fields, _firstName = _fields.firstName, firstName = _firstName === void 0 ? "" : _firstName, _lastName = _fields.lastName, lastName = _lastName === void 0 ? "" : _lastName, _picture = _fields.picture, picture = _picture === void 0 ? "" : _picture, displayName = _fields.displayName, _bio = _fields.bio, bio = _bio === void 0 ? "" : _bio, _website = _fields.website, website = _website === void 0 ? "" : _website, _twitterUsername = _fields.twitterUsername, twitterUsername = _twitterUsername === void 0 ? "" : _twitterUsername, _instagramUsername = _fields.instagramUsername, instagramUsername = _instagramUsername === void 0 ? "" : _instagramUsername, _linkedInUsername = _fields.linkedInUsername, linkedInUsername = _linkedInUsername === void 0 ? "" : _linkedInUsername;
    var initials = firstName.charAt(0) + lastName.charAt(0);
    var renderLink = function(url, iconComponent) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            "aria-label": "",
            href: url,
            target: "_blank",
            analyticsName: "",
            display: "flex",
            alignItems: "center",
            opacity: "0.2",
            _hover: {
                opacity: "1.0"
            },
            children: iconComponent
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core_Icon_SelectiveSpritesheet__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                icons: [
                    _opendoor_bricks_core_Icon_SpritesheetIcons_NewTab__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                flexDirection: "column",
                marginBottom: 4,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_complex__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .q, {
                        size: "lg",
                        src: picture,
                        initials: initials
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        marginTop: 4,
                        flexWrap: "wrap",
                        gridColumnGap: "4",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "span"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        children: displayName
                                    })),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "span"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        children: ",\xa0"
                                    })),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "i"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        fontWeight: "regular",
                                        children: props.roleText
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                gridGap: "4",
                                display: "inline-flex",
                                marginBottom: 2,
                                children: [
                                    twitterUsername && renderLink((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__/* .getSocialLink */ .a)("twitter", twitterUsername), /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        socialPlatform: "twitter"
                                    })),
                                    instagramUsername && renderLink((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__/* .getSocialLink */ .a)("instagram", instagramUsername), /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        socialPlatform: "instagram"
                                    })),
                                    linkedInUsername && renderLink((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__/* .getSocialLink */ .a)("linkedin", linkedInUsername), /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        socialPlatform: "linkedin"
                                    })),
                                    website && renderLink(website, /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core_Icon_Icon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        name: "new-tab",
                                        size: 16
                                    }))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        size: "s1",
                        marginTop: 0,
                        children: bio
                    })
                ]
            }, firstName + lastName)
        ]
    });
};



/***/ }),

/***/ 392474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArticleSchemaData */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(358699);



var getBaseTags = function(props) {
    if (!props.base || !props.base.fields) {
        return null;
    }
    var _fields = props.base.fields, canonicalUrl = _fields.canonicalUrl, metaDescription = _fields.metaDescription, title = _fields.title;
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("title", {
            children: title
        }, "title"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "description",
            content: metaDescription
        }, "description"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("link", {
            rel: "canonical",
            href: canonicalUrl
        }, "canonical"), 
    ];
};
var getOgTags = function(props) {
    if (!props.og || !props.ogArticle || !props.og.fields || !props.ogArticle.fields) {
        return null;
    }
    var _fields = props.og.fields, url = _fields.url, type = _fields.type, title = _fields.title, description = _fields.description, image = _fields.image, siteName = _fields.siteName;
    // TODO: may need to double check what time format these are in
    var _fields1 = props.ogArticle.fields, _publishedTime = _fields1.// fallback to article created at and updated at if not explicitly
    // provided
    publishedTime, publishedTime = _publishedTime === void 0 ? props.createdAt : _publishedTime, _modifiedTime = _fields1.modifiedTime, modifiedTime = _modifiedTime === void 0 ? props.updatedAt : _modifiedTime, expirationDate = _fields1.expirationDate, section = _fields1.section, tags = _fields1.tags;
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:title",
            content: title
        }, "og:title"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:type",
            content: type
        }, "og:type"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:url",
            content: url
        }, "og:url"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:image",
            content: image
        }, "og:image"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:description",
            content: description
        }, "og:description"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:site_name",
            content: siteName
        }, "og:site_name"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:published_time",
            content: publishedTime
        }, "og:article:published_time"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:modified_time",
            content: modifiedTime
        }, "og:article:modified_time"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:section",
            content: section
        }, "og:article:section"),
        expirationDate && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:expiration_time",
            content: expirationDate
        }, "og:article:expiration_time"),
        (props.authors || []).map(function(author) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:article:author",
                content: author.fields.displayName
            }, author.fields.displayName);
        }),
        (tags || []).map(function(tag) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:article:tag",
                content: tag
            }, tag);
        }), 
    ];
};
var getTwitterTags = function(props) {
    if (!props.card || !props.card.fields) {
        return null;
    }
    var _fields = props.card.fields, cardType = _fields.cardType, site = _fields.site, creatorTwitterHandle = _fields.creatorTwitterHandle, description = _fields.description, image = _fields.image, title = _fields.title;
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:card",
            content: cardType
        }, "twitter:card"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:site",
            content: site
        }, "twitter:site"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:creator",
            content: creatorTwitterHandle
        }, "twitter:creator"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:title",
            content: title
        }, "twitter:title"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:description",
            content: description
        }, "twitter:description"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:image",
            content: image
        }, "twitter:image"), 
    ];
};
var getCrawlerTags = function(props) {
    var follow = props.follow, index = props.index;
    if (follow && index) {
        return null;
    }
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "robots",
            content: [
                !follow && "nofollow",
                !index && "noindex"
            ].filter(Boolean).join(",")
        }, "robots"), 
    ];
};
// Export only for testing
var getArticleSchemaData = function(param) {
    var slug = param.slug, title = param.title, subtitle = param.subtitle, description = param.description, _authors = param.authors, authors = _authors === void 0 ? [] : _authors, editors = param.editors, reviewers = param.reviewers, image = param.image, publisher = param.publisher, createdAt = param.createdAt, updatedAt = param.updatedAt, tags = param.tags, section = param.section;
    var canonicalUrl = "https://www.opendoor.com".concat(slug);
    // Normalize dates to ISO 8601 datetime format
    // publishDate from Contentful is date-only, sys timestamps are full datetime
    var normalizedPublishedDate = createdAt.includes("T") ? createdAt : "".concat(createdAt, "T00:00:00.000Z");
    var schemaData = {
        "@context": "https://schema.org",
        "@type": "Article",
        "@id": canonicalUrl,
        mainEntityOfPage: canonicalUrl,
        dateModified: updatedAt,
        datePublished: normalizedPublishedDate,
        // TODO: use custom image for each article page
        image: [
            image,
            "https://images.opendoor.com/source/s3/imgdrop-production/1afd9b4404c54cd5bd4d3737eec0d70d.jpg?preset=square-2048", 
        ].filter(Boolean),
        inLanguage: "en-US"
    };
    if (title) schemaData.headline = title;
    if (subtitle) schemaData.alternativeHeadline = subtitle;
    if (description) schemaData.description = description;
    if (tags && tags.length > 0) schemaData.keywords = tags;
    if (section) schemaData.about = {
        "@type": "Thing",
        name: section
    };
    // Map authors to Person schema
    var authorPersons = authors.map(function(author) {
        var sameAs = [];
        if (author.twitterUsername) {
            sameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("twitter", author.twitterUsername));
        }
        if (author.linkedInUsername) {
            sameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("linkedin", author.linkedInUsername));
        }
        if (author.instagramUsername) {
            sameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("instagram", author.instagramUsername));
        }
        var url = author.website || (sameAs === null || sameAs === void 0 ? void 0 : sameAs[0]);
        var person = {
            "@type": "Person",
            name: author.displayName
        };
        if (url) person.url = url;
        if (sameAs.length > 0) person.sameAs = sameAs;
        return person;
    });
    if (reviewers && reviewers.length > 0) {
        reviewers.forEach(function(reviewer) {
            var reviewerPerson = {
                "@type": "Person",
                name: reviewer.displayName
            };
            if (reviewer.linkedInUsername) {
                reviewerPerson.sameAs = (0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("linkedin", reviewer.linkedInUsername);
            }
            authorPersons.push(reviewerPerson);
        });
    }
    if (authorPersons.length > 0) {
        schemaData.author = authorPersons;
    }
    if (editors && editors.length > 0) {
        var editor = editors[0];
        var editorPerson = {
            "@type": "Person",
            name: editor.displayName
        };
        if (editor.linkedInUsername) {
            editorPerson.sameAs = (0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("linkedin", editor.linkedInUsername);
        }
        schemaData.editor = editorPerson;
    }
    if (publisher) {
        var publisherSameAs = [];
        if (publisher.twitterUsername) {
            publisherSameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("twitter", publisher.twitterUsername));
        }
        if (publisher.linkedInUsername) {
            publisherSameAs.push("https://www.linkedin.com/company/".concat(publisher.linkedInUsername));
        }
        if (publisher.instagramUsername) {
            publisherSameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("instagram", publisher.instagramUsername));
        }
        if (publisher.youtubeChannel) {
            publisherSameAs.push("https://www.youtube.com/c/".concat(publisher.youtubeChannel));
        }
        if (publisher.facebookUsername) {
            publisherSameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("facebook", publisher.facebookUsername));
        }
        var publisherUrl = publisher.url || (publisherSameAs === null || publisherSameAs === void 0 ? void 0 : publisherSameAs[0]);
        var publisherOrg = {
            "@type": "Organization",
            name: publisher.name
        };
        if (publisherUrl) publisherOrg.url = publisherUrl;
        if (publisherSameAs.length > 0) publisherOrg.sameAs = publisherSameAs;
        if (publisher.logoUrl) {
            publisherOrg.logo = {
                "@type": "ImageObject",
                url: publisher.logoUrl
            };
        }
        schemaData.publisher = publisherOrg;
    }
    return schemaData;
};
var SeoHead = function(param) {
    var slug = param.slug, articleName = param.articleName, articleSubtitle = param.articleSubtitle, headerSummary = param.headerSummary, base = param.base, _authors = param.authors, authors = _authors === void 0 ? [] : _authors, _editors = param.editors, editors = _editors === void 0 ? [] : _editors, _reviewers = param.reviewers, reviewers = _reviewers === void 0 ? [] : _reviewers, og = param.og, ogArticle = param.ogArticle, twitterCard = param.twitterCard, sys = param.sys, publisher = param.publisher, publishDate = param.publishDate;
    // ensure that you don't nest tags inside of fragments
    // if you do that, then the next head component
    // will have issues with overrides
    var fields = (base === null || base === void 0 ? void 0 : base.fields) || {};
    var _index, _follow;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [
            getBaseTags({
                base: base
            }),
            getOgTags({
                og: og,
                ogArticle: ogArticle,
                createdAt: sys.createdAt,
                updatedAt: sys.updatedAt,
                authors: authors
            }),
            getTwitterTags({
                card: twitterCard
            }),
            getCrawlerTags({
                index: (_index = fields.index) !== null && _index !== void 0 ? _index : true,
                follow: (_follow = fields.follow) !== null && _follow !== void 0 ? _follow : true
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getArticleSchemaData({
                        slug: slug,
                        title: fields.title || articleName,
                        subtitle: articleSubtitle,
                        description: headerSummary || fields.metaDescription,
                        authors: authors.map(function(author) {
                            return author.fields;
                        }),
                        editors: editors.map(function(editor) {
                            return editor.fields;
                        }),
                        reviewers: reviewers.map(function(reviewer) {
                            return reviewer.fields;
                        }),
                        image: og === null || og === void 0 ? void 0 : og.fields.image,
                        publisher: publisher === null || publisher === void 0 ? void 0 : publisher.fields,
                        createdAt: publishDate || sys.createdAt,
                        updatedAt: sys.updatedAt,
                        tags: ogArticle === null || ogArticle === void 0 ? void 0 : ogArticle.fields.tags,
                        section: ogArticle === null || ogArticle === void 0 ? void 0 : ogArticle.fields.section
                    }))
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 287809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getArticleCategory; },
/* harmony export */   "p": function() { return /* binding */ articleTopicEnvRoot; }
/* harmony export */ });
/* harmony import */ var components_globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(735480);

var camelToTitleCase = function(str) {
    return str.replace(/([A-Z])/g, " $1").replace(/^./, function(char) {
        return char.toUpperCase();
    }).trim();
};
var EXCLUDE_TAGS = [
    "blog",
    "guide"
];
// nb tags may be alike 'homeBuyingTips'
var getArticleCategory = function(tags) {
    var categoryTag = tags === null || tags === void 0 ? void 0 : tags.find(function(tag) {
        return !EXCLUDE_TAGS.includes(tag);
    });
    if (!categoryTag) {
        return "";
    }
    return camelToTitleCase(categoryTag);
};
var articleTopicEnvRoot = components_globals__WEBPACK_IMPORTED_MODULE_0__/* .COSMOS_URL */ .EQ + "/articles" + (components_globals__WEBPACK_IMPORTED_MODULE_0__/* .DEPLOY_ENV */ .Zp === "production" ? "" : "-v2") + "/topic";


/***/ }),

/***/ 417919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useOnLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

// Periodically we want to load something after the window has loaded. This will
// do that, it also adds a buffer so it's definitely "afterLoad", these are for
// low-priority things.
var useOnLoad = function() {
    var onLoadStateChange = function onLoadStateChange() {
        setTimeout(function() {
            return setIsAfterLoad(true);
        }, 1000);
    };
    var handleLoadStateCleanup = function handleLoadStateCleanup() {
        window.removeEventListener("load", onLoadStateChange);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(// handle ssr
    typeof document === "undefined" ? false : document.readyState === "complete"), isAfterLoad = ref[0], setIsAfterLoad = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAfterLoad) {
            handleLoadStateCleanup();
            return;
        }
        window.addEventListener("load", onLoadStateChange);
        return handleLoadStateCleanup;
    }, [
        isAfterLoad
    ]);
    return isAfterLoad;
};


/***/ }),

/***/ 37680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(147568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(197582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(836808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_helpers_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(694886);
/* harmony import */ var components_helpers_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(139922);
/* harmony import */ var components_shared_trackers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(959431);
/* harmony import */ var _getPreferredLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(235374);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(371899);









var useLocale = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.ENGLISH */ .l.ENGLISH), locale = ref[0], setLocale = ref[1];
    var localeCookie = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get("locale");
    var anonId = (0,components_shared_trackers__WEBPACK_IMPORTED_MODULE_4__/* .getAnonymousId */ .y)();
    var localizationFeatureFlag = (0,components_helpers_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGetFeatureFlag */ .Gv)("growth-25-04-localization", "", {}, anonId);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var loadLangPref = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
                var preferredLocale, finalLocale;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (localizationFeatureFlag !== "on") {
                                setLocale(components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.ENGLISH */ .l.ENGLISH);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                (0,_getPreferredLocale__WEBPACK_IMPORTED_MODULE_5__/* .determinePreferredLocale */ .B)({
                                    localeFromCookie: localeCookie,
                                    anonId: anonId
                                })
                            ];
                        case 1:
                            preferredLocale = _state.sent();
                            finalLocale = preferredLocale || components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.ENGLISH */ .l.ENGLISH;
                            setLocale(finalLocale);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadLangPref() {
                return _ref.apply(this, arguments);
            };
        }();
        loadLangPref();
    }, [
        anonId,
        localeCookie,
        localizationFeatureFlag
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        _i18n__WEBPACK_IMPORTED_MODULE_6__/* .i18n.changeLanguage */ .ag.changeLanguage(locale);
    }, [
        locale
    ]);
    return locale;
};


/***/ }),

/***/ 941139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _name_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(135944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(370917);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(395674);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(897009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Link/Link.mjs
var Link = __webpack_require__(847208);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Image/Image.mjs
var Image_Image = __webpack_require__(61442);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(735480);
// EXTERNAL MODULE: ./src/helpers/socialLinks.ts
var socialLinks = __webpack_require__(358699);
// EXTERNAL MODULE: ./src/components/articles-v2/Person.tsx
var Person = __webpack_require__(995278);
// EXTERNAL MODULE: ./src/components/articles-v2/util.ts
var util = __webpack_require__(287809);
;// CONCATENATED MODULE: ./src/components/articles-v2/ArticleHeader.tsx







var ArticleCategoryBreadcrumbLink = {
    "Company News": "/company-news",
    "Home Buying Tips": "/moving-trends-insights",
    Sellers: "/sell",
    Buyers: "/buy",
    Agents: "/agent"
};
var ArticleHeader = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var articleCategory = (0,util/* getArticleCategory */.U)(props.sys.tags);
    // Only articles after the contentful migration will have a header image
    var headerImgUrl = (ref2 = (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.headerImage) === null || ref1 === void 0 ? void 0 : ref1.fields.file) === null || ref2 === void 0 ? void 0 : ref2.url;
    var headerImgAlt = ((ref3 = props.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.headerImage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.description) || ((ref6 = props.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.headerImage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : ref8.title);
    // Enumerate author/reviewer field props for readability
    var author = (ref9 = props.fields.authors) === null || ref9 === void 0 ? void 0 : ref9[0];
    var reviewer = (ref10 = props.fields.reviewers) === null || ref10 === void 0 ? void 0 : ref10[0];
    var ref12 = (author === null || author === void 0 ? void 0 : author.fields) || {}, authorDescription = ref12.description, authorContact = ref12.contact, authorLinkedIn = ref12.linkedInUsername, authorDisplayName = ref12.displayName;
    var ref13 = (reviewer === null || reviewer === void 0 ? void 0 : reviewer.fields) || {}, reviewerDescription = ref13.description, reviewerContact = ref13.contact, reviewerLinkedIn = ref13.linkedInUsername, reviewerDisplayName = ref13.displayName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                marginBottom: "$32x",
                $largerThanSM: {
                    marginBottom: 90,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    columnGap: "$12x"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        $largerThanSM: {
                            flexGrow: 12,
                            flexShrink: 1,
                            flexBasis: 12
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$labelMedium",
                                marginBottom: "$12x",
                                display: "flex",
                                alignItems: "center",
                                columnGap: "$3x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: globals/* COSMOS_URL */.EQ,
                                        "aria-label": "Home",
                                        analyticsName: "article-header-breadcrumb-home",
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        children: ">"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: globals/* COSMOS_URL */.EQ + "/newsroom",
                                        "aria-label": "Newsroom",
                                        analyticsName: "article-header-breadcrumb-newsroom",
                                        children: "Newsroom"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        children: ">"
                                    }),
                                    (ArticleCategoryBreadcrumbLink === null || ArticleCategoryBreadcrumbLink === void 0 ? void 0 : ArticleCategoryBreadcrumbLink[articleCategory]) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: util/* articleTopicEnvRoot */.p + ArticleCategoryBreadcrumbLink[articleCategory],
                                        "aria-label": articleCategory,
                                        analyticsName: "article-header-breadcrumb-article-category",
                                        children: articleCategory
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        children: articleCategory
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h1",
                                typography: "$headerLarge",
                                $largerThanSM: {
                                    typography: "$displayMedium"
                                },
                                children: props.fields.articleName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        paddingLeft: "$36x",
                        display: "none",
                        $largerThanSM: {
                            display: "block"
                        },
                        children: [
                            !props.fields.hideReadingTime && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$labelMedium",
                                marginBottom: "$20x",
                                children: [
                                    "Reading Time — ",
                                    props.readingTimeMinutes,
                                    " minutes"
                                ]
                            }),
                            props.fields.publishDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$bodyMedium",
                                marginBottom: "$4x",
                                children: [
                                    "Publication date:",
                                    " ",
                                    new Date(props.fields.publishDate + "T00:00:00").toLocaleDateString("en-us", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric"
                                    })
                                ]
                            }),
                            props.fields.actualizationDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$bodyMedium",
                                children: [
                                    "Actualization Date:",
                                    " ",
                                    new Date(props.fields.actualizationDate + "T00:00:00").toLocaleDateString("en-us", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                $largerThanSM: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    columnGap: "$16x"
                },
                marginBottom: props.fields.keyTakeaways && ((ref11 = props.fields.keyTakeaways) === null || ref11 === void 0 ? void 0 : ref11.content.length) > 0 ? "$32x" : 0,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        marginBottom: "$32x",
                        $largerThanSM: {
                            marginBottom: 0,
                            flexGrow: 4,
                            flexShrink: 1,
                            flexBasis: "20%"
                        },
                        children: [
                            props.fields.articleSubtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$headerSmall",
                                marginBottom: "$8x",
                                children: props.fields.articleSubtitle
                            }),
                            author && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        marginBottom: "$2x",
                                        children: "Author"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person/* PersonInline */.E, {
                                        person: author
                                    })
                                ]
                            }),
                            authorDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    children: authorDescription
                                })
                            }),
                            authorContact && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "Contact:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "mailto:".concat(authorContact),
                                        "aria-label": "Email ".concat(authorDisplayName || "author"),
                                        analyticsName: "article-header-author-email",
                                        children: authorContact
                                    })
                                ]
                            }),
                            reviewer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                marginTop: "$8x",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        marginBottom: "$2x",
                                        children: "Reviewer"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person/* PersonInline */.E, {
                                        person: reviewer
                                    })
                                ]
                            }),
                            reviewerDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    children: reviewerDescription
                                })
                            }),
                            reviewerContact && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "Contact:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "mailto:".concat(reviewerContact),
                                        "aria-label": "Email ".concat(reviewerDisplayName || "reviewer"),
                                        analyticsName: "article-header-reviewer-email",
                                        children: reviewerContact
                                    })
                                ]
                            }),
                            authorLinkedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "LinkedIn:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: (0,socialLinks/* getSocialLink */.a)("linkedin", authorLinkedIn),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "LinkedIn profile for ".concat(authorDisplayName || "author"),
                                        analyticsName: "article-header-author-linkedin",
                                        children: authorLinkedIn
                                    })
                                ]
                            }),
                            reviewerLinkedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "LinkedIn:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: (0,socialLinks/* getSocialLink */.a)("linkedin", reviewerLinkedIn),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "LinkedIn profile for ".concat(reviewerDisplayName || "reviewer"),
                                        analyticsName: "article-header-reviewer-linkedin",
                                        children: reviewerLinkedIn
                                    })
                                ]
                            })
                        ]
                    }),
                    headerImgUrl && headerImgAlt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "header-image",
                        marginBottom: 32,
                        $largerThanSM: {
                            marginBottom: 0,
                            flexGrow: 8,
                            flexShrink: 1,
                            flexBasis: "50%"
                        },
                        minWidth: 0,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image_Image/* default */.Z, {
                            src: headerImgUrl,
                            alt: headerImgAlt,
                            borderRadius: "roundedSmooth",
                            w: "100%",
                            h: "auto"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        children: [
                            !props.fields.hideReadingTime && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelMedium",
                                color: "$contentSecondary",
                                marginBottom: "$8x",
                                children: [
                                    "Reading Time — ",
                                    props.readingTimeMinutes,
                                    " minutes"
                                ]
                            }),
                            props.fields.publishDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: new Date(props.fields.publishDate + "T00:00:00").toLocaleDateString("en-us", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric"
                                })
                            }),
                            props.fields.actualizationDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelMedium",
                                color: "$contentSecondary",
                                children: new Date(props.fields.actualizationDate + "T00:00:00").toLocaleDateString("en-us", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(837337);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/fontTokens.js
var fontTokens = __webpack_require__(910533);
;// CONCATENATED MODULE: ./src/components/articles-v2/constants.ts


/* These styles are added as they have to be applied to the dynamic contents from contentful child nodes, 
so have to inject them as inline css
*/ var ArticleContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efd38so0"
})("width:100%;max-width:1440px;padding:64px 24px;margin:auto;> p,> ul,> ol,> blockquote,> hr,> table{grid-column:5 / -2;margin-bottom:0;}> h1,> h2,> h3,> h4{grid-column:4 / -2;margin-bottom:0;}> div{grid-column:1 / -1;margin-bottom:0;}hr{background-color:", (0,cjs.getToken)("$backgroundStateHoverSecondary"), ";border:none;grid-column:2 / -2;height:1px;margin-inline:auto;width:100%;}> * + *{margin-top:", (0,cjs.getToken)("$12x"), " !important;}> h1 + *,> h2 + *,> h3 + *,> h4 + *,> * + h1,> * + h2,> * + h3,> * + h4,> * + .embedded-entry-wrapper,> .embedded-entry-wrapper + *,> * + hr,> hr + *{margin-top:", (0,cjs.getToken)("$24x"), " !important;}@media (min-width:768px){display:grid;}");
var ArticleHeaderContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efd38so1"
})("> * + *{margin-top:24px;}> p:first-child{font-size:", (0,fontTokens/* getTypographyCSSVariable */.Pp)("$subheaderSmall", "size"), ";letter-spacing:", (0,fontTokens/* getTypographyCSSVariable */.Pp)("$subheaderSmall", "letterSpacing"), ";line-height:", (0,fontTokens/* getTypographyCSSVariable */.Pp)("$subheaderSmall", "lineHeight"), ";}> p:first-child + *{margin-top:", (0,cjs.getToken)("$32x"), ";}ul{list-style:none;margin-left:0;padding-left:0;}a,a:visited{color:", (0,cjs.getToken)("$contentPrimary"), ";}a:hover{color:", (0,cjs.getToken)("$backgroundAccentBrand"), ";}");


// EXTERNAL MODULE: ./src/components/articles-v2/seo/index.tsx
var seo = __webpack_require__(392474);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(921076);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StickyCTAUtility/StickyCTAUtility.tsx + 1 modules
var StickyCTAUtility = __webpack_require__(197661);
// EXTERNAL MODULE: ./src/pages/shared/LandingPageV2Layout.tsx + 4 modules
var LandingPageV2Layout = __webpack_require__(422064);
// EXTERNAL MODULE: ./src/cms/entries/articleV2.ts + 15 modules
var articleV2 = __webpack_require__(518834);
// EXTERNAL MODULE: ./src/components/articles-v2/renderer.tsx
var renderer = __webpack_require__(400818);
;// CONCATENATED MODULE: ./src/pages/articles-v2/[...name].tsx















var MAX_WIDTH = 1440;
var HEADER_HEIGHT = 65;
var Article = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref8 = (0,HeroShared/* useStickyCTA */.AJ)(), addressEntryRef = ref8.addressEntryRef, showStickyCTAUtility = ref8.showStickyCTAUtility;
    var hideStickyCta = authentication.state === "authenticated";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LandingPageV2Layout["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                slug: props.fields.slug,
                articleName: props.fields.articleName,
                articleSubtitle: props.fields.articleSubtitle,
                headerSummary: props.fields.headerSummary,
                og: props.fields.openGraph,
                ogArticle: props.fields.openGraphArticle,
                base: props.fields.seoBase,
                authors: props.fields.authors,
                editors: props.fields.editors,
                reviewers: props.fields.reviewers,
                twitterCard: props.fields.twitterCard,
                sys: props.sys,
                publisher: props.fields.publisher,
                publishDate: props.fields.publishDate
            }),
            !hideStickyCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTAUtility/* StickyCTAUtility */.V, {
                analyticsId: "article-detail",
                isVisible: showStickyCTAUtility,
                style: {
                    top: "80px"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                tag: "article",
                backgroundColor: "$backgroundSecondary",
                marginTop: HEADER_HEIGHT,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        backgroundColor: "$backgroundPrimary",
                        paddingVertical: 64,
                        paddingHorizontal: 24,
                        borderBottomRightRadius: 64,
                        borderBottomLeftRadius: 64,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            ref: function(el) {
                                return addressEntryRef(el);
                            },
                            maxWidth: MAX_WIDTH,
                            marginHorizontal: "auto",
                            width: "100%",
                            $largerThanSM: {
                                paddingHorizontal: "$10x"
                            },
                            $largerThanMD: {
                                paddingHorizontal: "$20x"
                            },
                            $largerThanLG: {
                                paddingHorizontal: "$32x"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleHeader, (0,_object_spread/* default */.Z)({}, props)),
                                props.fields.keyTakeaways && ((ref = props.fields.keyTakeaways) === null || ref === void 0 ? void 0 : ref.content.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                        $largerThanSM: {
                                            marginLeft: "calc((4 * 1/12) * 100%)"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "p",
                                                typography: "$bodyMedium",
                                                marginBottom: "$8x",
                                                children: "Summary"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleHeaderContainer, {
                                                className: "font_body",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                                                    body: props.fields.keyTakeaways,
                                                    idToLoaderData: props.idToLoaderData,
                                                    entryLookup: articleV2/* default */.Z
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleContainer, {
                        style: {
                            gridTemplateColumns: "repeat(12, minmax(0, 1fr))"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                            body: props.fields.body,
                            idToLoaderData: props.idToLoaderData,
                            entryLookup: articleV2/* default */.Z
                        })
                    }),
                    props.fields.showAuthorFooter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        justifyContent: "center",
                        flexDirection: "row",
                        marginBottom: 64,
                        paddingHorizontal: 24,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            $largerThanSM: {
                                flexDirection: "row"
                            },
                            alignItems: "center",
                            columnGap: "$8x",
                            rowGap: "$16x",
                            children: [
                                ((ref1 = props.fields.authors) === null || ref1 === void 0 ? void 0 : ref1[0].fields.picture) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    height: 96,
                                    width: 96,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-shrink:0;"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                        source: {
                                            uri: (ref2 = props.fields.authors) === null || ref2 === void 0 ? void 0 : ref2[0].fields.picture
                                        },
                                        alt: "Photo of ".concat((ref3 = props.fields.authors) === null || ref3 === void 0 ? void 0 : ref3[0].fields.displayName),
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;width:100%;height:100%;border-radius:50%;")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$subheaderXsmall",
                                            $largerThanSM: {
                                                typography: "$subheaderSmall"
                                            },
                                            marginBottom: "$4x",
                                            children: ((ref4 = props.fields.authors) === null || ref4 === void 0 ? void 0 : ref4[0].fields.displayName) && ((ref5 = props.fields.authors) === null || ref5 === void 0 ? void 0 : ref5[0].fields.displayName)
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$subheaderXsmall",
                                            $largerThanSM: {
                                                typography: "$subheaderSmall"
                                            },
                                            children: ((ref6 = props.fields.authors) === null || ref6 === void 0 ? void 0 : ref6[0].fields.bio) && ((ref7 = props.fields.authors) === null || ref7 === void 0 ? void 0 : ref7[0].fields.bio)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ var _name_ = (Article);


/***/ }),

/***/ 422064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shared_LandingPageV2Layout; },
  "getLandingpageV2ServerSideProps": function() { return /* binding */ getLandingpageV2ServerSideProps; },
  "getPreloadsFromLoaderData": function() { return /* binding */ getPreloadsFromLoaderData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(135944);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/@opendoor/shared-fe/build/faviconPath.js
var faviconPath = __webpack_require__(71390);
// EXTERNAL MODULE: ./node_modules/next/dist/server/api-utils/index.js
var api_utils = __webpack_require__(738464);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(809008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(596887);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(735480);
// EXTERNAL MODULE: ./src/components/helpers/types.ts
var types = __webpack_require__(139922);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toast/Toast.js + 3 modules
var Toast = __webpack_require__(264370);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SelectiveSpritesheet.mjs
var SelectiveSpritesheet = __webpack_require__(387583);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ArrowLeft.mjs
var ArrowLeft = __webpack_require__(320201);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ArrowRight.mjs
var ArrowRight = __webpack_require__(935636);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Close.mjs
var Close = __webpack_require__(727959);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/text.mjs
var components_text = __webpack_require__(9225);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(669666);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(836808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/cms/utils.ts
var utils = __webpack_require__(746000);
// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(454991);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(959431);
// EXTERNAL MODULE: ./src/helpers/getPreferredLocale.ts
var getPreferredLocale = __webpack_require__(235374);
// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(543552);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 22 modules
var Header = __webpack_require__(412149);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(395674);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js + 7 modules
var Dialog = __webpack_require__(760179);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(125923);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/VisitorModal.tsx




var GetCashOfferModal = function(entry) {
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        var timer;
        if (authentication.state === "not_authenticated") {
            var hasShownDialog = localStorage.getItem("getCashOfferModalShown");
            if (!hasShownDialog) {
                timer = setTimeout(function() {
                    setIsOpen(true);
                    localStorage.setItem("getCashOfferModalShown", "true");
                }, 400);
            }
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        authentication.state
    ]);
    var handleClose = function() {
        setIsOpen(!isOpen);
    };
    var analyticsName = "cosmos-landing-page-visitor-modal-".concat(entry === null || entry === void 0 ? void 0 : entry.analyticsId);
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        isOpen: isOpen,
        dismissable: largerThanSM ? true : false,
        animation: "accelerateDecelerateFast",
        setIsOpen: handleClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            maxWidth: 504,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                title: entry.title,
                titleProps: {
                    typography: "$subheaderLarge",
                    $largerThanSM: {
                        typography: "$headerLarge"
                    }
                },
                description: entry.description,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    $largerThanSM: {
                        pt: "$24x"
                    },
                    pt: "$16x",
                    children: [
                        !largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            variant: "secondary",
                            size: "small",
                            analyticsName: analyticsName,
                            label: "Close",
                            onPress: handleClose
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            marginTop: "$4x",
                            variant: "primary",
                            size: "small",
                            $largerThanSM: {
                                size: "medium"
                            },
                            onPress: function() {
                                document.location.href = "https://www.opendoor.com/address-entry";
                            },
                            analyticsName: "".concat(analyticsName, "-cash-offer-cta"),
                            label: "Get a cash offer"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var VisitorModal = (GetCashOfferModal);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/Layout.tsx

























var MaintenanceBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 716).then(__webpack_require__.bind(__webpack_require__, 240716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(240716)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2912).then(__webpack_require__.bind(__webpack_require__, 562912));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(562912)
            ];
        }
    }
});
var LANGUAGE_TOAST_SEEN_KEY = "language-toast-seen";
var ctaLink;
var Layout = function(param) {
    var header = param.header, slug = param.slug, footer = param.footer, extraLegalText = param.extraLegalText, showEligibilityLegal = param.showEligibilityLegal, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal, showPromotionLegal = param.showPromotionLegal, children = param.children, showModal = param.showModal, modalTitle = param.modalTitle, modalDescription = param.modalDescription, modalAnalyticsId = param.modalAnalyticsId, showLanguageToggle = param.showLanguageToggle;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,react.useState)(false), showLanguageToast = ref11[0], setShowLanguageToast = ref11[1];
    (0,react.useEffect)(function() {
        var checkLanguagePreference = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var hasSeenLanguageToast, localeCookie, anonId, preferredLocale;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            hasSeenLanguageToast = localStorage.getItem(LANGUAGE_TOAST_SEEN_KEY) === "true";
                            if (hasSeenLanguageToast) {
                                return [
                                    2
                                ];
                            }
                            localeCookie = js_cookie_default().get("locale");
                            anonId = (0,trackers/* getAnonymousId */.y)();
                            return [
                                4,
                                (0,getPreferredLocale/* determinePreferredLocale */.B)({
                                    localeFromCookie: localeCookie,
                                    anonId: anonId
                                })
                            ];
                        case 1:
                            preferredLocale = _state.sent();
                            // show toggle for auto-defaulted users only
                            if (preferredLocale === types/* LOCALES.SPANISH */.l.SPANISH) {
                                setShowLanguageToast(true);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkLanguagePreference() {
                return _ref.apply(this, arguments);
            };
        }();
        checkLanguagePreference();
    }, []);
    var handleLanguageToastClose = function() {
        setShowLanguageToast(false);
        localStorage.setItem(LANGUAGE_TOAST_SEEN_KEY, "true");
    };
    // build nav here, and check for mainNavLinks && menuPanelNavLinks
    // to show the header
    var mainNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref = header.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.mainNav) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(link) {
        // mainNav can now be ILpElementLink (simple) or ILpElementSimpleList (with sections)
        // Only extract simple links for mainNavLinks
        if (!(0,utils/* isSimpleLink */.$)(link)) return;
        if (!link.fields.text || !link.fields.url) return;
        mainNavLinks.push({
            name: link.fields.text,
            href: link.fields.url
        });
    });
    var menuPanelNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref2 = header.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.menuPanelNav) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(link) {
        if (link.fields.text && link.fields.url) {
            menuPanelNavLinks.push({
                name: link.fields.text,
                href: link.fields.url
            });
        }
    });
    var ctaTitle = header === null || header === void 0 ? void 0 : header.fields.menuPanelCtaTitle;
    if ((header === null || header === void 0 ? void 0 : (ref4 = header.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.menuPanelCta) === null || ref5 === void 0 ? void 0 : ref5.fields.text) && (header === null || header === void 0 ? void 0 : (ref6 = header.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.menuPanelCta) === null || ref7 === void 0 ? void 0 : ref7.fields.url)) {
        ctaLink = {
            name: header.fields.menuPanelCta.fields.text,
            href: header.fields.menuPanelCta.fields.url
        };
    }
    var getOfferExperiment = (0,queryParams/* default */.Z)().getOfferExperiment;
    var showGetCashOfferModal = showModal && getOfferExperiment === "treatment";
    // Transform header.mainNav (union type) into MegaNavItem[] format
    var megaNavData = (0,cms/* transformHeaderNavToMegaNav */.$C)(header === null || header === void 0 ? void 0 : (ref8 = header.fields) === null || ref8 === void 0 ? void 0 : ref8.mainNav);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
        baseTheme: "novo",
        team: "growth",
        launchDateString: new Date().toISOString(),
        // NOTE: This is a hack to fix responsive sizing due to issues in the feature's figma designs
        // TODO(@product-growth): Remove this when the design system is updated
        overrides: {
            components: {
                Text: {
                    sizes: UpdatedTextSizing
                },
                Heading: {
                    sizes: UpdatedTextSizing
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-regular/Graphik-Regular.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-medium/Graphik-Medium.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-semibold/Graphik-Semibold.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-bold/Graphik-Bold.woff2",
                        as: "font"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectiveSpritesheet/* default */.Z, {
                icons: [
                    ArrowLeft/* default */.Z,
                    ArrowRight/* default */.Z,
                    Close/* default */.Z
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaintenanceBanner, {}),
            showGetCashOfferModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VisitorModal, {
                title: modalTitle,
                description: modalDescription,
                analyticsId: modalAnalyticsId
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                display: "block",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        menuPanelNavLinks: menuPanelNavLinks,
                        mainNavLinks: mainNavLinks,
                        ctaTitle: ctaTitle,
                        ctaLink: ctaLink,
                        slug: slug,
                        showLanguageToggle: showLanguageToggle,
                        megaNavData: megaNavData
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            width: "100%",
                            margin: 0,
                            display: "block",
                            children: [
                                children,
                                footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                                    footerImage: (ref9 = footer.fields.footerImage) === null || ref9 === void 0 ? void 0 : ref9.fields.file.url,
                                    footerTitle: footer.fields.footerTitle,
                                    footerImageTitle: (ref10 = footer.fields.footerImage) === null || ref10 === void 0 ? void 0 : ref10.fields.title,
                                    footerNav: footer.fields.footerNav,
                                    googlePlaystoreLink: footer.fields.googlePlaystoreLink,
                                    appleStoreLink: footer.fields.appleStoreLink,
                                    helpCenterLink: footer.fields.helpCenterLink,
                                    backgroundColor: footer.fields.backgroundColor,
                                    extraLegalText: extraLegalText,
                                    showCustomerTestimonialLegal: showCustomerTestimonialLegal,
                                    showEligibilityLegal: showEligibilityLegal,
                                    showPromotionLegal: showPromotionLegal,
                                    showThePdpCopyrightLegal: showThePdpCopyrightLegal,
                                    locale: footer.sys.locale
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* Toast */.F, {
                message: "No todo el contenido est\xe1 disponible en espa\xf1ol. Puedes actualizar tu preferencia de idioma en el men\xfa.",
                isOpen: showLanguageToast,
                onClose: handleLanguageToastClose,
                duration: 5000,
                analyticsName: "spanish-nofify"
            })
        ]
    });
};
/**
 * All the following typography overrides are for the 2023 Homepage Reskin project
 * https://www.figma.com/file/g2qLawddmhROv347l6EF7m/HP-Reskin?type=design&node-id=325-28241&mode=design&t=5CA6uSlmM7nuVuIC-0
 * TODO: re-assess overrides after experiment is over
 *
 * NOTE: This object gets deep merged w/ the novo theme so we only need to define the differences
 */ var UpdatedTextSizing = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, components_text/* sizes */.J), {
    100: {
        fontSize: [
            "14px",
            null,
            null,
            "18px"
        ],
        lineHeight: "140",
        letterSpacing: "-1.4"
    },
    // Used in FAQsDisplay, VideoHero, ReviewCard, MenuPanel
    110: {
        fontSize: [
            "16px",
            null,
            "14px",
            "16px"
        ],
        lineHeight: [
            "25.6px",
            null,
            "25.6px",
            "160%"
        ],
        letterSpacing: [
            "-1.4%",
            "-0.014em",
            "-0.014em",
            "-0.018em"
        ]
    },
    // Used in Hero, ReviewCard
    120: {
        fontSize: "18px",
        lineHeight: "120",
        letterSpacing: "-2.4"
    },
    // Used in StickyCTAUtility
    130: {
        fontSize: [
            "16px",
            null,
            "19px"
        ],
        lineHeight: "19px",
        letterSpacing: "-2.4"
    },
    // Used in Footer, Hero
    140: {
        fontSize: "22px",
        lineHeight: "112",
        letterSpacing: "-2.4"
    },
    // Used in FAQsDisplay, MapBackgroundHero, Steps, Testimonials, TextSection
    150: {
        fontSize: [
            "16px",
            null,
            null,
            "24px"
        ],
        lineHeight: [
            "130%",
            null,
            null,
            "112%"
        ],
        letterSpacing: [
            "-0.014em",
            null,
            null,
            "-0.028em"
        ]
    },
    // Used in HeroCard, VideoHero
    160: {
        fontSize: [
            "18px",
            "19px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in CarouselCards, Footer
    170: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "56px"
        ],
        lineHeight: [
            "35.2px",
            "36px",
            "44px",
            "56px"
        ],
        letterSpacing: [
            "-2.8",
            "-3",
            "-3.4"
        ],
        fontWeight: 500
    },
    // Used in ImageCard
    180: {
        fontSize: [
            "16px",
            "18px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in HeroCard, ImageCard
    220: {
        fontSize: [
            "22.2px",
            "28px",
            "36px",
            "56px"
        ],
        lineHeight: [
            "106%",
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.028em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    // Used in FAQsDisplay, MapBackgroundHero, TextSection
    230: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "64px"
        ],
        lineHeight: [
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.028em",
            "-0.03em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    240: {
        fontSize: [
            "36px",
            null,
            "80px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    250: {
        fontSize: [
            "44px",
            null,
            "88px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    260: {
        fontSize: [
            "60px",
            null,
            "96px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    }
});
/* harmony default export */ var landing_pages_v2_Layout = (Layout);

// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(977997);
// EXTERNAL MODULE: ./src/components/shared/useOnLoad.ts
var useOnLoad = __webpack_require__(417919);
;// CONCATENATED MODULE: ./src/components/shared/usePromptGoogleOneTap.ts




/**
 * Prompt the user to sign in with Google One Tap with built in error tracking + analytics
 * @param page - The page name to use for analytics tracking
 */ var usePromptGoogleOneTap = function(page, onSuccess, disablePromptGoogleOneTap, delay) {
    var ref = (0,observability/* useObservability */.C3)(), trackEvent = ref.trackEvent, trackError = ref.trackError;
    var ref1 = (0,auth_fe_esm/* useAuth */.aC)(), authentication = ref1.authentication, refresh = ref1.refresh;
    var isAfterLoad = (0,useOnLoad/* useOnLoad */.g)();
    (0,react.useEffect)(function() {
        // don't fire off the import until the document is finished loading
        if (authentication.state !== "not_authenticated" || !isAfterLoad || disablePromptGoogleOneTap) {
            return;
        }
        var prompt = function() {
            __webpack_require__.e(/* import() */ 1878).then(__webpack_require__.bind(__webpack_require__, 791878)).then(function(param) {
                var promptGoogleOneTap = param.promptGoogleOneTap;
                promptGoogleOneTap("cosmos-".concat(page), function() {
                    onSuccess && onSuccess();
                    refresh();
                }, trackEvent, trackError);
            });
        };
        var timer;
        if (delay) {
            timer = setTimeout(prompt, delay);
        } else {
            prompt();
        }
        return function() {
            clearTimeout(timer);
        };
    }, [
        authentication.state,
        isAfterLoad,
        delay
    ]);
};

// EXTERNAL MODULE: ./src/helpers/useLocale.ts
var useLocale = __webpack_require__(37680);
;// CONCATENATED MODULE: ./src/schema/index.ts
var HOMEPAGE_SCHEMA = {
    "@context": "http://schema.org",
    "@type": "Organization",
    legalName: "Opendoor Labs, Inc.",
    alternateName: "Opendoor",
    url: "https://www.opendoor.com",
    contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-888-352-7075",
        contactType: "Customer Service"
    },
    address: {
        "@type": "PostalAddress",
        addressLocality: "San Francisco",
        addressCountry: "USA",
        postalCode: "94104",
        streetAddress: "1 Post St, Fl 11"
    },
    logo: "https://www.opendoor.com/w/wp-content/uploads/2019/04/Opendoor-Logo.jpg",
    sameAs: [
        "https://www.facebook.com/OpendoorHQ",
        "https://twitter.com/opendoor",
        "https://www.youtube.com/channel/UCKKVV4bx18EtclsdNOFzWBw",
        "https://www.linkedin.com/company/opendoor-com",
        "https://www.pinterest.com/opendoorhq",
        "https://en.wikipedia.org/wiki/Opendoor", 
    ]
};


;// CONCATENATED MODULE: ./src/pages/shared/LandingPageV2Layout.tsx
















var getSeoBaseTags = function(fields) {
    var title = fields === null || fields === void 0 ? void 0 : fields.title;
    var metaDescription = fields === null || fields === void 0 ? void 0 : fields.metaDescription;
    var canonicalUrl = fields === null || fields === void 0 ? void 0 : fields.canonicalUrl;
    var robots = [];
    // only set these when they are explicitly set to false
    // otherwise assume indexing and follow should be allowed
    if ((fields === null || fields === void 0 ? void 0 : fields.index) === false) {
        robots.push("noindex");
    }
    if ((fields === null || fields === void 0 ? void 0 : fields.follow) === false) {
        robots.push("nofollow");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: title !== null && title !== void 0 ? title : "Opendoor | Sell your home the minute you’re ready."
            }, "title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "shortcut icon",
                href: (0,faviconPath/* default */.Z)({
                    railsEnv: globals/* DEPLOY_ENV */.Zp
                }),
                type: "image/png"
            }),
            metaDescription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: metaDescription
            }, "description") : null,
            canonicalUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robots.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "robots",
                content: robots.join(",")
            }, "robots") : null
        ]
    });
};
var getOpenGraphTags = function(openGraphFields) {
    var url = openGraphFields.url, type = openGraphFields.type, title = openGraphFields.title, description = openGraphFields.description, image = openGraphFields.image, siteName = openGraphFields.siteName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: type
            }, "og:type"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: url
            }, "og:url"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: image
            }, "og:image"),
            ",",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:site_name",
                content: siteName
            }, "og:site_name")
        ]
    });
};
// when a no-code landing page needs to preload an image for performance reasons,
// it can include a `preloadImages` field in the loader data
// this function crunches the loader data and pulls out all the preload images
// so that the top-level page can include those preload urls in the Head section
var getPreloadsFromLoaderData = function(idToLoaderData) {
    return Object.values(idToLoaderData).map(function(loaderData) {
        return loaderData === null || loaderData === void 0 ? void 0 : loaderData.preloadImages;
    }).filter(function(preload) {
        return preload;
    }).flat();
};
var getLandingpageV2ServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, pageNum, slug, cookieParser, localeFromCookie, locale, props, showModal, excludedSlugs, modalProps, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((ref = context.params) === null || ref === void 0 ? void 0 : ref.slug)) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    pageNum = 1;
                    if (context.query.page) {
                        pageNum = parseInt(context.query.page);
                    }
                    if (pageNum < 1) pageNum = 1;
                    slug = "";
                    // if slug is a string and not an array
                    if (typeof context.query.slug === "string") {
                        slug = context.query.slug;
                    } else if (Array.isArray(context.query.slug)) {
                        slug = context.query.slug.join("/");
                    }
                    cookieParser = (0,api_utils/* getCookieParser */.ac)(context.req.headers);
                    localeFromCookie = cookieParser().locale;
                    locale = localeFromCookie === types/* LOCALES.SPANISH */.l.SPANISH ? types/* LOCALES.SPANISH */.l.SPANISH : types/* LOCALES.ENGLISH */.l.ENGLISH;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        (0,cms/* fetchLandingPageV2BySlug */.AL)({
                            slug: slug,
                            requestUrl: context.resolvedUrl,
                            pageNum: pageNum,
                            locale: locale
                        })
                    ];
                case 2:
                    props = _state.sent();
                    if (!props) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    // check if the page is set to public, and reject if appropriate
                    // this is intended to block non-public pages from being directly accessed by users,
                    // while still letting them be used in experiments as treatments
                    if (context.query.public && props.public === false) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    showModal = false;
                    excludedSlugs = [
                        "builder",
                        "agent",
                        "real-estate",
                        "homepage",
                        "login",
                        "register",
                        "reset-password",
                        "calculator",
                        "careers",
                        "safety",
                        "privacy"
                    ];
                    if (!excludedSlugs.every(function(excluded) {
                        return !slug.includes(excluded);
                    })) return [
                        3,
                        4
                    ];
                    showModal = true;
                    return [
                        4,
                        (0,cms/* getCashOfferModal */.Mq)()
                    ];
                case 3:
                    modalProps = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        {
                            props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                modalFields: showModal && modalProps ? {
                                    title: modalProps.fields.title,
                                    description: modalProps.fields.description,
                                    analyticsId: modalProps.fields.analyticsId
                                } : null,
                                showModal: !!(showModal && modalProps)
                            })
                        }
                    ];
                case 5:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        2,
                        {
                            notFound: true
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLandingpageV2ServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var LandingPageV2Layout = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    usePromptGoogleOneTap("landing-pages-v2-".concat(props.fields.slug), undefined, props.hideGoogleOneTap);
    (0,useLocale/* useLocale */.b)();
    var contextualData = {
        landingPageSlug: props.fields.slug
    };
    var imagePreloads = getPreloadsFromLoaderData(props.idToLoaderData);
    var openGraphFields = (ref = props.fields.openGraph) === null || ref === void 0 ? void 0 : ref.fields;
    var appleStatusBarColor = props.fields.slug === "homepage-syw-v2-home-guide" ? "black" : "default";
    var shouldIncludeTrustpilot = (ref1 = props.fields) === null || ref1 === void 0 ? void 0 : ref1.shouldShowTrustpilotReviews;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(observability_slim/* AddContextualData */.up, {
        data: contextualData,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    getSeoBaseTags((ref2 = props.fields.seoBase) === null || ref2 === void 0 ? void 0 : ref2.fields),
                    openGraphFields && getOpenGraphTags(openGraphFields),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "apple-mobile-web-app-status-bar-style",
                        content: appleStatusBarColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(HOMEPAGE_SCHEMA)
                        }
                    }),
                    shouldIncludeTrustpilot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "text/javascript",
                        src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                        async: true
                    }),
                    imagePreloads.map(function(h) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                            rel: "preload",
                            as: "image",
                            media: h.media,
                            // @ts-expect-error: react incorrectly capitalizes this if you use
                            // the "typescript" suggestion of `imgSrcSet`
                            imagesrcset: h.srcSet,
                            fetchpriority: "high"
                        }, h.key);
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        as: "image",
                        href: "https://images.opendoor.com/source/s3/imgdrop-production/2023-08-1692902240043-86611.jpg?preset=square-512"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landing_pages_v2_Layout, {
                header: (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : ref3.header,
                slug: "/".concat((ref4 = props.fields) === null || ref4 === void 0 ? void 0 : ref4.slug),
                footer: (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : ref5.footer,
                showModal: props.showModal,
                modalTitle: (ref6 = props.modalFields) === null || ref6 === void 0 ? void 0 : ref6.title,
                modalDescription: (ref7 = props.modalFields) === null || ref7 === void 0 ? void 0 : ref7.description,
                modalAnalyticsId: (ref8 = props.modalFields) === null || ref8 === void 0 ? void 0 : ref8.analyticsId,
                extraLegalText: (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : ref9.extraLegalText,
                showEligibilityLegal: (ref10 = props.fields) === null || ref10 === void 0 ? void 0 : ref10.showEligibilityLegal,
                showCustomerTestimonialLegal: (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : ref11.showCustomerTestimonialLegal,
                showThePdpCopyrightLegal: (ref12 = props.fields) === null || ref12 === void 0 ? void 0 : ref12.showThePdpCopyrightLegal,
                showPromotionLegal: (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : ref13.showPromotionLegal,
                showLanguageToggle: (ref14 = props.fields) === null || ref14 === void 0 ? void 0 : ref14.showLanguageToggle,
                children: props.children
            })
        ]
    });
};
/* harmony default export */ var shared_LandingPageV2Layout = (LandingPageV2Layout);


/***/ }),

/***/ 142141:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
function cov_2aeau7yxor() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTab.tsx";
  var hash = "fd7172e4b020de994de21291bf9b33d5c136fd04";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTab.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fd7172e4b020de994de21291bf9b33d5c136fd04"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2aeau7yxor = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2aeau7yxor();
var Icon = (cov_2aeau7yxor().s[0]++, {
  name: 'new-tab',
  svg: "<path d=\"M21.9498 10.0267L22.0065 1.98876L13.1912 2.05015C12.5008 2.05496 11.9451 2.61849 11.9499 3.30882C11.9547 3.99916 12.5182 4.5549 13.2086 4.55009L17.4399 4.52062L10.1161 11.8444C9.6279 12.3326 9.6279 13.1241 10.1161 13.6122C10.6042 14.1004 11.3957 14.1004 11.8838 13.6122L19.478 6.01801L19.4499 10.0091C19.445 10.6994 20.0007 11.263 20.6911 11.2678C21.3814 11.2727 21.945 10.717 21.9498 10.0267Z\" fill=\"currentColor\"/>\n  <path d=\"M4.44995 7.25H9.19995C9.89031 7.25 10.45 6.69035 10.45 6C10.45 5.30964 9.89031 4.75 9.19995 4.75H4.19995C2.95731 4.75 1.94995 5.75736 1.94995 7V20C1.94995 21.2426 2.95731 22.25 4.19995 22.25H17.2C18.4426 22.25 19.45 21.2426 19.45 20V14C19.45 13.3096 18.8903 12.75 18.2 12.75C17.5096 12.75 16.95 13.3096 16.95 14V19.75H4.44995V7.25Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9842,2767,6500,5569,5923,6559,5662,7166,6937,5675,2447,1782,1378,4468,7488,6970,4746,2864,7890,5175,5261,4370,7649,8058,1462,940,8834,7432,6887,9774,2888,179], function() { return __webpack_exec__(486819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);